export default function Spinner() {
    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem"}}/>
            </div>
            <div className="d-flex justify-content-center" />
        </>
    );
}
